import { ButtonHTMLAttributes, forwardRef, useId } from 'react';
import { Spinner } from '../../Spinner';
import { cn } from '../utils';

export interface A11yButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
}

export const A11yButton = forwardRef<HTMLButtonElement, A11yButtonProps>(
  (
    { children, isLoading, className, disabled, onClick, onKeyDown, ...rest },
    ref,
  ) => {
    const id = useId();

    return (
      <button
        ref={ref}
        aria-disabled={disabled}
        onClick={(e) => {
          if (disabled) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          onClick?.(e);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && disabled) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          onKeyDown?.(e);
        }}
        className={cn(
          'lf:relative ',
          {
            'lf:cursor-not-allowed': disabled,
          },
          className,
        )}
        {...rest}
      >
        {isLoading && (
          <span className="lf:absolute lf:inset-0 lf:flex lf:items-center lf:justify-center lf:rounded-[inherit] lf:bg-inherit lf:hover:bg-inherit">
            <Spinner name={`button-spinner-${id}`} />
          </span>
        )}
        {children}
      </button>
    );
  },
);
A11yButton.displayName = 'A11yButton';
